// iconClass maps the icon names the apps and memberState use to Line Awesome
// classes, so both draw the same icons (spec 010).
const classes: Record<string, string> = {
  home: 'la-home', school: 'la-graduation-cap', work: 'la-briefcase', shopping: 'la-shopping-bag',
  sport: 'la-futbol', health: 'la-heartbeat', family: 'la-users', pin: 'la-map-marker-alt',
  car: 'la-car-side', walking: 'la-walking', running: 'la-running', bicycle: 'la-biking',
  'location-arrow': 'la-location-arrow', pause: 'la-pause-circle', hand: 'la-hand-paper',
  question: 'la-question-circle', exclamation: 'la-exclamation-circle', route: 'la-route',
  flag: 'la-flag-checkered',
  bus: 'la-bus', train: 'la-train', plane: 'la-plane',
};

export function iconClass(name: string): string {
  return `las ${classes[name] ?? 'la-map-marker-alt'}`;
}

// placeIcons lists the icons a place may carry, in the order the editor offers them.
export const placeIcons = ['home', 'school', 'work', 'shopping', 'sport', 'health', 'family', 'pin'] as const;

export const placeIconLabels: Record<string, string> = {
  home: 'Home', school: 'School', work: 'Work', shopping: 'Shopping', sport: 'Sport', health: 'Health', family: 'Family', pin: 'Pin',
};
